import { HttpClient, HttpHeaders } from '@angular/common/http';

export class APIService {
  currentUser;
  private baseUrl = "https://joinus.albaraka.com.sy/joinus/backend/public/api/"; 
  protected endPoint = "";
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
    })
  };
  constructor(protected http: HttpClient) {
  }
  get url() {
    return this.baseUrl + this.endPoint;
  }
}
